import { useQuery } from "@tanstack/react-query";

import {
  getReportTemplates,
  PaginationMeta,
  ReportTemplate,
} from "@services/reportEngine";

export const useReportTemplates = (params: Record<string, any>) => {
  return useQuery<{ reportTemplates: ReportTemplate[]; meta: PaginationMeta }>(
    ["reportTemplates", params],
    () => getReportTemplates(params),
    { keepPreviousData: true, refetchOnWindowFocus: false },
  );
};
